import { Component, OnInit, Injector } from '@angular/core';
import { scheduleI, scheduleStatus } from 'app/core/interfaces/schedule';
import * as moment from 'moment';
import { scheduleFilter } from 'app/core/data/forms.json';
import { statusSchedule } from 'app/core/data/calendar.json';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { organizationI } from 'app/core/interfaces/organization';
import { tabI } from 'app/core/interfaces/layout';
import { ScheduleEditStatusComponent } from './edit-status/schedule-edit-status.component';
import { ScheduleDetailsComponent } from './details/schedule-details.component';

@Component({
  selector: 'page-schedule-status',
  templateUrl: './schedule-status.component.html',
  styleUrls: ['./schedule-status.component.scss'],
})
export class ScheduleStatusComponent extends BaseComponent implements OnInit {
  public title = 'Status de atendimento';
  public atendimentos: scheduleI[] = [];
  public scheduleStatus: scheduleStatus[] = statusSchedule;
  public tipoSchedule: number = 0;
  public buscarSchedule = '';
  public filterTipos = scheduleFilter;
  public tabs: tabI[] = [];
  public registrosExibidos: number = 10;

  public get atendimentosFiltro(): scheduleI[] {
    const atendimentos = [...this.atendimentos];
    const currentDate = moment();

    return atendimentos.sort((a: scheduleI, b: scheduleI) => {
      const dateA = moment(a.dateStart);
      const dateB = moment(b.dateStart);

      const diffA = Math.abs(dateA.diff(currentDate, 'days'));
      const diffB = Math.abs(dateB.diff(currentDate, 'days'));

      return diffA - diffB;
    });
  }

  public get atendimentosFinalizados(): scheduleI[] {
    const atendimentos = [...this.atendimentosFiltro];
    return atendimentos.filter((item: scheduleI) => !!item.dateEnd);
  }

  public get atendimentosEmAberto(): scheduleI[] {
    const atendimentos = [...this.atendimentosFiltro];
    return atendimentos.filter((item: scheduleI) => !item.dateEnd);
  }

  ngOnInit(): void {
    this.getSchedules();
    this.initTabs();
  }

  constructor(private injector: Injector) {
    super(injector);
  }

  pesquisar() {
    const atendimentos = { ...this.atendimentos };
    //this.atendimentos = atendimentos.filter((item: scheduleI) =>
    // item.practioner?.name.indexOf(this.buscarSchedule) ||  item.procedure?.name.indexOf(this.buscarSchedule) || this.tipoSchedule == 0 ||
    // (this.tipoSchedule > 0 &&  ((this.tipoSchedule == 1 && item.type == 'Consulta') || (this.tipoSchedule == 2 && item.type == 'Exame')))
    // );
  }

  openComponentDialogScheduleDetailForm(schedule: scheduleI) {
    const data = {
      title: `Dados do atendimento - ${schedule.id}`,
      param: { id: schedule.id },
    };

    this.dialog.openComponentDialog(ScheduleDetailsComponent, data);
  }

  openComponentDialogScheduleEditStatusForm(schedule: scheduleI) {
    const data = {
      title: `Alterar status - ${schedule.id}`,
      param: { schedule },
    };

    this.dialog.openComponentDialog(ScheduleEditStatusComponent, data);
  }

  getTextStatus(statusCode: any) {
    return this.scheduleStatus.find(
      (item: scheduleStatus) => item.id === statusCode
    )?.text;
  }

  getColorStatus(statusCode: any) {
    const color = this.scheduleStatus.find(
      (item: scheduleStatus) => item.id === statusCode
    )?.color;
    return color ? color : '';
  }

  getSchedules() {
    // Simulando chamada ao backend
    this.atendimentos = this.auth.getFromLocalStorage(
      'schedules'
    ) as scheduleI[];
    // Filtrando registros com data igual ou posterior à data atual
    const currentDate = moment().startOf('day');
    this.atendimentos = this.atendimentos.filter((item) =>
      moment(item.date).isSameOrAfter(currentDate)
    );
  }

  getOrganizationName(organizationId: number) {
    return this.auth
      .getFromLocalStorage('organizations')
      .find((item: organizationI) => item.id == organizationId).name;
  }

  getContent(tabId: number) {
    return tabId == 1
      ? this.atendimentosEmAberto
      : this.atendimentosFinalizados;
  }

  initTabs() {
    this.tabs = [
      {
        id: 1,
        title: 'Agendados',
      },
      {
        id: 2,
        title: 'Finalizados',
      },
    ];
  }

  loadMore() {
    this.registrosExibidos += 10;
  }
}
